/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 7/13/14
 * Time: 4:15 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var CategoriesGridModel;

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        CategoriesGridModel = BaseModel.extend({

            defaults: {
                filters:{

                },
                comparators:{
                    "name": "name",
                    "order": "order",
                    "proposed": "proposed",
                    "assignedContent": "assignedContent",
                    "assignedCampaigns": "assignedCampaigns"
                }
            },
            name: "CategoriesGridModel",

            pluck: function (_model) {
                return true;
            }
        });
    });

    return CategoriesGridModel;
});
